import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { TranslateService } from '@ngx-translate/core';
import { GuiService } from 'src/app/services/gui.service';
import { RestService } from 'src/app/services/rest.service';
import { environment } from 'src/environments/environment';
import { driver } from "driver.js";

@Component({
  selector: 'vex-diary',
  templateUrl: './diary.component.html',
  styleUrls: ['./diary.component.scss']
})
export class DiaryComponent implements OnInit {
  percentage: number = 0;
  environment = environment.baseURL.workout_programs;
  completedThropies: any;
  thropiesLoaded: boolean = false;

  constructor(public guiService: GuiService, public translate: TranslateService, private restService: RestService) { }

  ngOnInit() {
    this.guiService.showSpinner = false;
    if (this.guiService.userLogged) {
      this.getThropies();
      if(this.guiService.programs.length < 1){
        this.guiService.getPrograms();
      }
      setTimeout(() => {
        localStorage.getItem('tourDiaryShowed') ? null : this.startTour();
      }, 1000);
    } else {
      this.guiService.goTo('main/home');
    }
  }

  startTour(): void {
    localStorage.setItem('tourDiaryShowed', 'true');

    const driverObj = driver({
      showProgress: true,
      allowClose: true,
      steps: [
        { element: '.week-thropies-diary', popover: { title: this.translate.instant('TUTORIALS.diary.checkTrophiesTitle'), description: this.translate.instant('TUTORIALS.diary.checkTrophiesDescription'), side: 'bottom' } },
        { element: '.box-1', popover: { title: this.translate.instant('TUTORIALS.diary.accessWorkoutHistoryTitle'), description: this.translate.instant('TUTORIALS.diary.accessWorkoutHistoryDescription') } },
        { element: '.box-2', popover: { title: this.translate.instant('TUTORIALS.diary.viewOverloadHistoryTitle'), description: this.translate.instant('TUTORIALS.diary.viewOverloadHistoryDescription') } },
        { element: '.box-3', popover: { title: this.translate.instant('TUTORIALS.diary.reviewFavoriteWorkoutsTitle'), description: this.translate.instant('TUTORIALS.diary.reviewFavoriteWorkoutsDescription') } }
      ]
    });

    driverObj.drive();
  }

  countWeeklyWorkout(): number | null {
    const obj = this.guiService?.currentProgram?.weeks[this.guiService?.userLogged?.workoutInfo.programs[this.guiService?.currentProgram?._id].week];
    return obj ? Object.values(obj).filter((item: { id?: any }) => item?.id !== null && item?.id !== undefined).length : null;
  }

  workoutCompletedInWeek(){
    const week = this.guiService?.userLogged?.workoutInfo.programs[this.guiService?.currentProgram?._id].week;
    const progress = this.guiService.userLogged?.workoutInfo?.programs[this.guiService.currentProgram._id]?.progress;

    let number: number = 0;
    for(let key in progress["week_"+week]){
      if(progress["week_"+week][key] && typeof progress["week_"+week][key] === 'object' &&(progress["week_"+week][key].status === 'COMPLETED' || progress["week_"+week][key].status === 'FORCED_COMPLETED')){
        number++;
      }
    }
    return number;
  }

  getThropies() {
    this.thropiesLoaded = false;
    console.debug(this.guiService.userLogged)
    this.restService.postService("node", "/get-user-thropies", { userId: this.guiService.userLogged.user.id, }).subscribe((ris) => {
      console.debug("thropies", ris);
      this.completedThropies = ris.filter((x) => x.unlocked === true).length;
      this.thropiesLoaded = true;
    });
  }
}

